import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";
// import PreviewCompatibleImage from "../components/PreviewCompatibleImage";

// eslint-disable-next-line
export const CommunicationPageTemplate = ({ title, content, contentComponent }) => {
  const PageContent = contentComponent || Content;

  return (
    <section className="section section--gradient">
      <div className="container">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div className="section">
              {/* <div className="section">
                <PreviewCompatibleImage imageInfo={image} />
              </div> */}
              <h2 className="title is-size-3 has-text-weight-bold is-bold-light">
                {title}
              </h2>
              <PageContent className="content" content={content} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

CommunicationPageTemplate.propTypes = {
  // image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
};

const CommunicationPage = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout>
      <CommunicationPageTemplate
        // image={post.frontmatter.image}
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
      />
    </Layout>
  );
};

CommunicationPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default CommunicationPage;

export const communicationPageQuery = graphql`
  query CommunicationPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`;
